module.exports = __webpack_public_path__ + "img/icono_escenario.279daa9a.png";